import { ODOO_COMPANY_IDS } from "AppSettings";
import Button from "components/base/Button";
import { Select } from "components/base/Form";
import { useModals } from "ModalProvider";
import { OdooContext } from "OdooProvider";
import OdooCustomersView from "pages/retailer/retailers/OdooCustomersView";
import { useContext } from "react";
import { CustomerContext } from "./CustomerPage";
import OdooCustomerInfoView from "./OdooCustomerInfoView";

const CustomerBasicInfoView = () => {
  const { customer, save, saveRes } = useContext(CustomerContext);
  const { odooUrl } = useContext(OdooContext);

  const modal = useModals();

  function showOdooCustomers() {
    modal.present({
      title: "Connect Odoo Customer",
      children: (
        <OdooCustomersView
          onSelect={onSelectOdooCustomer}
          useType="LINK_CUSTOMER"
        />
      ),
    });
  }

  function onSelectOdooCustomer(odooCustomer) {
    modal.hide();

    save({
      variables: {
        id: customer.id,
        odooPartnerId: odooCustomer.id,
      },
    });
  }

  function quickSave(values) {
    save({
      variables: {
        id: customer.id,
        ...values,
      },
      optimisticResponse: {
        updateCustomer: {
          customer: { ...customer, ...values },
          __typename: "UpdateCustomer",
        },
      },
    });
  }

  return (
    <div className="card">
      <div className="flex justify-between items-baseline">
        <div>
          <h5>Basic Info</h5>
          <div className="opacity-70">
            Customer basic information is managed in Odoo.
          </div>
        </div>

        <div className="flex space-x-4 items-center">
          {customer.odooPartnerId && (
            <a
              href={`${odooUrl}/web#cids=${ODOO_COMPANY_IDS[customer.system]}&menu_id=408&action=744&model=res.partner&view_type=form&id=${
                customer.odooPartnerId
              }`}
              className=" text-purple-600 dark:text-purple-700"
              target="_blank"
              rel="noopener noreferrer"
            >
              Edit in Odoo
            </a>
          )}

          <Button odoo onClick={showOdooCustomers}>
            Connect Odoo Customer
          </Button>
        </div>
      </div>

      <div className="mt-2 space-y-2">
        <div className="flex space-x-3 items-center">
          <label>Company: </label>
          <Select
            value={customer.system}
            onChange={(e) => {
              quickSave({ system: e.target.value });
            }}
            disabled={saveRes.loading}
          >
            <option>AB</option>
            <option>LTD</option>
          </Select>
        </div>

        {customer.odooPartnerId ? (
          <OdooCustomerInfoView customer={customer} />
        ) : (
          <div className="text-pink-600 font-semibold">
            Please connect to Odoo customer to complete the customer setup.
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerBasicInfoView;
